import React from 'react';
import PropTypes from 'prop-types';

export default class ProgressBar extends React.Component {

  render() {
    const percentage = parseInt(this.props.percentage, 10);
    return(
      <div className={`progress-bar progress-bar-${percentage}`}>
        <div className="progress-bar-titles">
          <span className="progress-bar-title-start">Au début du projet</span>
          <span className="progress-bar-title-end">Prêt à vous lancer</span>
        </div>
        <div className="progress-bar-bar">
          <div className="progress-bar-bg"></div>
          <div className="progress-bar-dividers">
            <div className="progress-bar-divider"></div>
            <div className="progress-bar-divider"></div>
            <div className="progress-bar-divider"></div>
            <div className="progress-bar-divider"></div>
            <div className="progress-bar-divider"></div>
          </div>
          <div className="progress-bar-progress" style={{width: `${percentage}%`}}></div>
          <div className="progress-bar-progress-icon" style={{left: `${percentage}%`}}>
            <div className="progress-bar-progress-icon-text">
              <span>{percentage}</span>
            </div>
            <div className="progress-bar-progress-icon-circle"></div>
          </div>
        </div>
      </div>
    )
  }
}

ProgressBar.propTypes = {
  percentage: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/views/components/ProgressBar.js